import React from 'react'
import PropTypes from 'prop-types'
import * as Icons from '../icons'

function BackButton ({ children, size = 'default', onClick = null }) {
  return (
    <button type='button' className={'btn-back btn-back--' + (size)} onClick={onClick}>
      <Icons.ArrowLeft className='' />
      <span>{children}</span>
    </button>
  )
}

BackButton.propTypes = {
  onClick: PropTypes.func,
  size: PropTypes.oneOf([
    'default',
    'big'
  ])
}

export default BackButton
